(function () {
  document.querySelectorAll('[data-youtube-wrap]').forEach(function (wrap) {
    var playBtn = wrap.querySelector('[data-video-play]');
    if (!playBtn) return;

    playBtn.addEventListener('click', function () {
      var videoId = wrap.getAttribute('data-video-id');
      var videoType = wrap.getAttribute('data-video-type');

      var src =
        videoType === 'vimeo'
          ? 'https://player.vimeo.com/video/' + videoId + '?autoplay=1'
          : 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0&playsinline=1&loop=1';
          // : 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0&playsinline=1';
          
      var iframe = document.createElement('iframe');
      iframe.className = 'collab-video-banner__youtube';
      iframe.setAttribute('src', src);
      iframe.setAttribute('allow', 'autoplay; encrypted-media; fullscreen; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('frameborder', '0');

      wrap.innerHTML = '';
      wrap.appendChild(iframe);
    });
  });
})();
